import React from 'react';
import { Reveal } from './Reveal';
const withoutItems = ['😓 Répéter les mêmes schémas sans savoir pourquoi', '🔁 Une thérapie qui traite les symptômes, pas les racines', '💭 Se sentir cassé sans pouvoir l’expliquer', '😰 Transmettre les mêmes blessures à vos enfants', '🌙 Vivre toute sa vie dans l’histoire de quelqu’un d’autre'];
const withItems = ['📖 Ouvrir votre carte de constellation', '🎯 Identifier le schéma racine — pas juste le symptôme', '💪 Appliquer la phrase de guérison. Ressentir le changement.', '♾️ Briser le cycle complètement et consciemment', '📅 Écrire l’héritage que vous seul pouvez laisser'];
function Panel({
  title,
  label,
  items,
  positive
}: {
  title: string;
  label: string;
  items: string[];
  positive?: boolean;
}) {
  return <div className={`p-7 sm:p-10 ${positive ? 'bg-surface' : 'bg-mist'}`} data-id="element-29" data-mp="9ke0n65mai15">
      <p className={`text-xs font-bold uppercase tracking-[0.16em] ${positive ? 'text-sage' : 'text-red-500'}`} data-id="element-30" data-mp="eiz3zeg61htt">
        {label}
      </p>
      <h3 className="mt-4 font-serif text-3xl leading-tight text-navy" data-id="element-31" data-mp="1m1qz9dv8zsd3">{title}</h3>
      <ul className="mt-7 divide-y divide-navy/10" data-id="element-32" data-mp="1h9h15ajzblzq">
        {items.map(item => <li key={item} className="py-4 text-sm leading-relaxed text-slate sm:text-base" data-id="element-33" data-mp="1d85kvvmzwd47">
            {item}
          </li>)}
      </ul>
    </div>;
}
export function Comparison() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-34" data-mp="24zbd7pwh56ix">
      <div className="mx-auto max-w-6xl" data-id="element-35" data-mp="24xh3l7qnl0u5">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="20xgfevdr5b9w">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-37" data-mp="20vvhqww55c7t">
            ⚖️ La différence qu’un <span className="text-sage" data-id="element-38" data-mp="1vx27ddc5i1bv">vrai système</span> fait
          </h2>
          <p className="mt-5 text-slate" data-id="element-39" data-mp="1qz0ootin040x">
            Vous n’achetez pas des fichiers. Vous achetez un système complet de guérison opérationnel.
          </p>
        </Reveal>
        <Reveal delay={0.08} data-id="element-40" data-mp="fkdkytwjyxsx">
          <div className="mt-10 overflow-hidden rounded-2xl border border-navy/10 shadow-elevated md:grid md:grid-cols-2" data-id="element-41" data-mp="fj2906syejqq">
            <Panel label="❌ Sans le système" title="Sans le Système des Constellations Familiales™" items={withoutItems} data-id="element-42" data-mp="gzzikeyx0d88" />
            <Panel positive label="✅ Avec le système" title="Avec le Système des Constellations Familiales™" items={withItems} data-id="element-43" data-mp="80mb1rucpyq5" />
          </div>
        </Reveal>
      </div>
    </section>;
}